import React, {useEffect,useContext,useState,useRef,SyntheticEvent} from 'react';
import { DataContext } from 'contexts/DataContext';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';

import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { get,update } from './api'
import Info from '@mui/icons-material/Info';
import { toast } from 'react-toastify';

const Context = () => {
    const dataContext = useContext(DataContext);
    const [context, setContext] = useState({} as any);
    const [currentTabIndex, setCurrentTabIndex] = useState(0);
    const [saving, setSaving] = useState(false);
    
    const formRef = useRef<HTMLFormElement>(null);

    const handleTabChange = (e: SyntheticEvent, tabIndex: number) => {
      setCurrentTabIndex(tabIndex);
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        dataContext.changeShowLoader(true);
        const data = new FormData(event.currentTarget);

        update(dataContext.currentAssessment, data, 1).then((response) => {
            setContext(response);
            toast.success('Context saved', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
            
            setSaving(false);
            dataContext.changeShowLoader(false);
        
        });
    };

    useEffect(() => {
        if(dataContext.loading) return;
        if(!dataContext.currentAssessment) return;
        get(dataContext.currentAssessment, 1).then((response) => {
            setContext(response);
        });
    }, [dataContext.loading, dataContext.currentAssessment]);

    return (
        <AppLayout drawerOpen={true} drawer={<AppDrawer />} 
        title={<><Typography variant='pageTitle'>Context</Typography></>} 
        actions={dataContext.user?.id_role===1 ? [] :[
            {
                label: saving ? 'Saving...' : 'Save',
                disabled: saving ? true : false,
                action: (event: SyntheticEvent) => {
                    setSaving(true);
                    formRef.current?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }
            }
        ]}>

    
        <Box ref={formRef} component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 0 }}>
        {context?.contextRows && Object.keys(context?.contextRows).map((key, index) => {
            return (
                <Box key={index} sx={{display:currentTabIndex===index?'block':'none'}}>
                {context?.contextRows[key].map((row:any) => {
                    return (
                        <Paper sx={{marginTop:1, padding:1}} key={row.id}>

                        <Box sx={{margin:1}}>
                            <Grid container spacing={2} alignItems='center'>
                                <Grid item xs={8}>
                                    <Item>
                                        <Typography sx={{fontSize:14}}>
                                            <span dangerouslySetInnerHTML={{__html: row.text}}></span>
                                        </Typography>
                                    </Item>
                                </Grid>

                                <Grid item xs={1}>
                                    <Item>
                                        {row.answer_type===1 && 
                                        <Switch 
                                        value={'1'}
                                        name={`answer[${row.id}]`} 
                                        key={context?.context[row.id]?.answer ? '1' : '0'} 
                                        defaultChecked={context?.context[row.id]?.answer ? true : false} 
                                        disabled={dataContext.user?.id_role===1 ? true : false}
                                        />}
                                    </Item>
                                </Grid>

                                <Grid item xs={3}>
                                    <Item>
                                        <TextField
                                            name={`note[${row.id}]`}
                                            multiline
                                            maxRows={4}
                                            sx={{ minHeight: '100%' }}
                                            variant="filled"
                                            fullWidth
                                            hiddenLabel
                                            key={context?.context[row.id]?.note || ''}
                                            defaultValue={context?.context[row.id]?.note || ''}
                                            disabled={dataContext.user?.id_role===1 ? true : false}
                                        />
                                    </Item>
                                </Grid>
                            </Grid>
                        </Box>
                        </Paper>

                    )
                })}
                </Box>
            );
        })}
        </Box>
      </AppLayout>
    )
}

export default Context;